<template>
  <div id="app">
    <nav-bar ref="navLaber" :isLoginBox="isLoginBox" :isIndex="isIndex" :isShowMenu="isShowMenu" :isShowSearch="isShowSearch"></nav-bar>
    <router-view />
  </div>
</template>

<script>
    import NavBar from "@/components/NavBar/index.vue"
    export default {
        components:{
            NavBar,
        },
        name: '',
        data() {
            return {
              clientHeight: '',                 //窗口高度
              navHeight:'',                     //头部高度
              routerView:null,
              isIndex: true,                    //是否是首页
              isLoginBox:false,                 //是否是登录页
              isShowMenu:true,                  //是否显示导航栏
              isShowSearch:true,                //是否显示搜索条
            }
        },
        mounted(){
            // 获取浏览器可视区域高度
            this.clientHeight = `${document.documentElement.clientHeight}` 
            window.onresize = function temp() {
              this.clientHeight = `${document.documentElement.clientHeight}`;
            };

            //头部高度
            this.navHeight = this.$refs.navLaber.$el.clientHeight;
        },
        watch: {
            $route: 'handleRoute',
            // 如果 `clientHeight` 发生改变，这个函数就会运行
            clientHeight: function () {
                let difHeight = Number(this.clientHeight) - Number(this.navHeight) - 80;  //80是底部高度
                localStorage.setItem("difHeight",difHeight); 
            }
        },
        methods: {
              
            /**
             * 路由操作处理
             */
            handleRoute (route) { 
                let routes = route.path;
                if(routes == "/login" || routes == "/forgetpwd"){
                    this.isLoginBox = true;
                    this.isIndex = false;
                    this.isShowMenu = true;
                }
                else if(routes == "/search"){
					          this.isShowSearch = false;
                    this.isShowMenu = false;
                }else{
					          this.isShowSearch = true;
                    this.isLoginBox = false;
                    this.isIndex = true;
                    this.isShowMenu = false;
                    if(routes == "/index" || routes == "/courseIndex" || routes == "/coursePage"  ){
                        this.isShowMenu = true;
                    }
                }
            },

        },


    }
</script>

<style>

  /* 修改样式 */
  .navSearch .el-input__inner{ 
      border-radius: 10px;
      background-color: #f2f3f7;
      border: none;
      height: 36px;
  }  
  .navSearch.navLeftSearch .el-input__inner{ 
      background-color: #ffffff;
      border: 1px solid #f7f7f7;
      height: 40px;
  }

  /* 公共样式 */
  *{
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    -ms-box-sizing: border-box;
    touch-action: pan-y;
    margin: 0;
    padding: 0;
    font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  }
  a{
    text-decoration: none;
  }
  em{
    font-style: normal;
  }
  u{
      text-decoration: none;
  }
  i{
      font-style: normal;
  }
  strong{
      font-weight: normal;
  }
  h5,h6 , p{
      padding: 0;
      margin: 0;
  }
  li{
    list-style: none;
  }
  .tr{
      text-align: right;
  }
  .flex{
      display: flex;
      justify-content: center;
      align-items: center;
  }
  .justify-content{
      justify-content: left;
  }
  .jcright{
    justify-content: right;
  }
  .space-between{
    justify-content: space-between;
  }
  .flex1{
    flex: 1;
  }
  .section{
    width: 1200px;
    margin: auto;
    overflow: hidden;
  }
  .w1300{
    width: 1200px;
   }
  .ptb70{
    padding: 70px 0;
  }
  .ptb30{
    padding: 30px 0;
  }
  .bgColor.difColor{
      background-color:#fff;
  }
  .bgColor.difColor a{
      color:#333 !important;
      font-weight: bold;
  }
  .bgColor.difColor a.selected{
      color: #fff !important;;
  }
  .img{
      width: 100%;
      display: block;
  }
  .mb20{
      margin-bottom: 20px;
  }
  .blue , .blue a{
     color: #2297ff;
  }
  .blueBg{
     color: #24b8fe;
     border-color: #24b8fe; 
  }
	.pr{
		position: relative;
	}
	.banner{
		width: 1200px;
		position:absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
		color: #fff;
	}
	.banner > p{
		font-size: 25px;
		margin-bottom: 20px;
	}
	.banner > span{
		font-size: 20px;
	}
  .white{
    color: #fff;
  }
  .black{
    color: #333;
  }
  .overflow{
    overflow: hidden;
  }
  .tc{
    text-align:center;
  }
  .innerBg{
    height: 170px;
    background: url('../src/assets/images/bg01.png') 100% 100% no-repeat;
		z-index: -1;
  }
  .w1100{
    width: 1100px;
    margin: auto;
  }
  .mtb90{
    margin: 90px auto;
  }
  .mtb50{
    margin: 50px auto;
  }
  .pb30{
		padding-bottom: 20px;
	}
  .block{
      display: block;
  }
  .mr40{
		margin-right: 40px;
	}
  .pointer{
      cursor: pointer;
  }
  .f12{
      font-size: 12px;
  }
  .fw{
    font-weight: bold;
  }
  .color1{
    color: #333 !important;
  }
  .pl0{
    padding-left:0 !important;
  }
  .mb70{
      margin-bottom: 70px;
  }
  .price{
    color: #d35e0b;
    font-size: 14px;
  }
  .noData{
    width: 100%;
    min-height: 350px;
    text-align: center;
    position: relative;
  }
  .noDataBox{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }
  .noDataBox > i{
    display: block;
    font-size: 35px;
    color: #d5d5d5;
  }
  .noDataBox > span{
    font-size: 14px;
    color: #666;
    padding-top: 5px;
    display: inline-block;
  }
  .lyIcon{
      width: 50px;
      height: 50px;
      background-color: #333333;
      text-align: center;
      line-height: 50px;
      border-radius: 50%;
      color: #fff;
      font-size: 15px;
  }

  .saveChanges{
      background-color: #17b3fe;
      color: #fff;
      border-radius: 10px;
      border-color: #17b3fe;
      padding:15px 35px;
	}



  /* 修改默认样式 */
  .elTabs .el-tabs__nav-scroll{
    width: 1200px;
    margin: auto;
    height: 70px;
    line-height: 70px;
  }
  .elTabs .el-tabs__item{
      font-weight: bold;
      color: #333;
  }
  .el-tabs__active-bar {
      background-color: #198cff;
  }
  .elTabs  .el-tabs__nav-wrap{
    box-shadow: 0px 0px 10px #e7e7e7;
  }
  .elTabs .el-tabs__nav-wrap::after {
      content: "";
      background-color:transparent;
  }
  .navLeftSearch .el-input__suffix{
      top: 12px;
      right: 12px;
  }
  .elRate .el-rate__icon {
		  margin-right: 0;
	}
	.el-pager li.active{
      background-color: #24b8ff !important;
      border-radius: 50% !important;
      display: inline-block !important;
      margin: 0 !important;
      padding: 0 !important;
      width: 35.5px !important;
      height: 35.5px !important;
      line-height: 35.5px !important;
      color: #fff !important;
      font-weight: normal !important;
	}
  .el-pager li , .el-pagination button, .el-pagination span:not {
      width: 35.5px;
      height: 35.5px;
      line-height: 35.5px;
  }
  .el-pager li , .el-pagination button, .el-pagination span:not([class*=suffix]) {
      width: 35.5px;
      height: 35.5px;
      line-height: 35.5px;
      color: #666;
  }
  .el-breadcrumb__inner a, .el-breadcrumb__inner.is-link , .el-breadcrumb__item:last-child .el-breadcrumb__inner , .el-breadcrumb__item:last-child .el-breadcrumb__inner, .el-breadcrumb__inner.is-link:hover {
      color: #fff !important;
  }
  .el-breadcrumb__separator{
      color: #fff;
      margin: 0 15px;
  }
  .elRateCons .el-rate__text{
    display: none;
  }
  .percentage .el-progress__text{
    font-size: 13px !important;
    padding-left: 10px;
    box-sizing: border-box  !important;
    color: #333;
  }
  .buy-menu.el-menu.el-menu--horizontal{
      border-bottom: none;
  }
  .buy-menu.el-menu--horizontal>.el-submenu .el-submenu__title{
      color: #000 !important;
      border-bottom:none !important;
      padding: 0 10px !important;
  }
  .buy-box .el-badge__content.is-fixed{
      width: 18px;
      font-size: 12px;
      text-align: center;
      padding: 0;
      margin-top: 5px;
  }
	.perElTabs .el-tabs__item {
      font-weight: normal;
      color: #fff;
      font-size: 15px;
      padding: 0 25px;
	}
  .perElTabs .el-tabs__header {
      margin: 0;
  }
  .perElTabs .el-tabs__nav-wrap::after{
      height: 0;
  }
  .perElTabs .el-tabs__active-bar {
      background-color: #ffffff;
  }
	.courseCard .el-card__header{
      padding: 18px 40px;
      background-color: #f7f7f7;
	}
  .courseCard .clearfix > span{
      color: #333;
      font-weight: bold;
  }
  .courseCard.el-card.is-always-shadow{
      box-shadow:none;
  }
  .elMenu {
      border: solid 1px #e6e6e6;
  }
  .elMenu .el-submenu__icon-arrow{
      left: 20px !important;
      right: auto;
  }
  .elMenu .el-submenu{
      background-color: #f7f7f7;
  }
  .elMenu .el-submenu .el-menu{
     padding-left: 20px;
  }
  .elMenu li.el-submenu  ul li.el-submenu {
      background-color:transparent;
  }
  .elMenu .el-submenu .el-menu-item{
      padding: 0 20px !important;
  }
  .elMenu  li ul li .el-submenu__title {
    height: 50px;
    line-height: 50px;
  }
  .breadBox .el-breadcrumb__inner a, .breadBox .el-breadcrumb__inner.is-link ,.breadBox .el-breadcrumb__item:last-child .el-breadcrumb__inner ,.breadBox .el-breadcrumb__item:last-child .el-breadcrumb__inner, .breadBox .el-breadcrumb__inner.is-link:hover {
      color: #333 !important;
  }
  .breadBox .el-breadcrumb__separator{
      color: #333;
      margin: 0 15px;
  }
  .breadBox .el-breadcrumb__inner.is-link{
      font-weight: normal;
  }


  .elCols{
    margin-top: 30px;
  }
  .elCols > label{
    display: flex;
    align-items: center;
    float: left;
  }

  /* 登陆 */
  .logins .el-tabs__nav-wrap::after{
    height: 0;
  }
  .logins .el-tabs__item{
      color: #999999;
      font-size: 18px;
      font-weight: bold;
  }
  .logins .el-tabs__nav-scroll{
    margin-bottom: 10px;
  }

  .logins .el-tabs__item.is-active {
      color: #444647;
  }

  .logins .el-tabs__active-bar{
      height: 4px;
      border-radius: 10px;
      background-color: #cfeffe;
  }
  .logins  .el-tabs__header{
    margin: 0;
  }
  .checkboxs .el-checkbox__input.is-checked+.el-checkbox__label {
      color: #959595;
  }
  .login_box .el-input__inner{
      border-radius: 16px;
      background-color: #f8f9fb;
      border: none;
  }
  .login_box .checkboxs .el-checkbox__input.is-checked+.el-checkbox__label {
      color: #999;
  }
  .login_box .el-checkbox__label > a{
      color: #24b7fd;
      text-decoration: underline;
  }
  .steps .el-step__title.is-process,.steps .el-step__icon-inner  {
      color: #c0c4cc;
  }
  .steps .el-step__head.is-process{
      border-color: #c0c4cc;
  }
  .steps .el-step__title.is-success {
      color: #ffffff;
  }
  .steps .el-step__head.is-success {
      color: #ffffff;
      border-color: #ffffff;
  }
  .el-menu--horizontal .el-menu .el-menu-item.minMenu{
    padding: 0 20px;
  }
  .el-menu--horizontal .el-menu .el-menu-item.minMenu:hover{
    background-color: #f9f9f9;
  }
  .RateBtn  .rateCourse{
		background: transparent;
		color: #24b8ff;
		border: none;
	}
 	.courseCard.el-card > .el-card__header{
		border-bottom: none !important;
	}
  .courseDes{
    padding-right: 40px;
    box-sizing: border-box;
  }
  .noBgelMenu.elMenu .el-submenu{
    background: transparent;
  }
  .noBgelMenu.elMenu{
    border:none;
  }
	.chatMenu .el-submenu__icon-arrow{
		display: none;
	}
  .queTabs .el-tabs__item{
      font-size: 16px;
  }
  .itemsModel {
    display: block;
  }
  .itemsModel .el-form-item__label{
    font-size: 15px;
    color: #333;
    font-weight: bold;
    float:none;
  }
  .itemsModel .el-form-item__content{
    margin-left:0 !important;
  }
  .itemsModel .el-input__inner{
    background-color: #f2f3f7;
    border: none;
    height: 43px !important;
  }
  .elDialogs .el-dialog__body{
    padding-top: 10px;
  }
  .mtb40{
    margin: 40px auto;
  }
  .jdQue .el-form-item__content{
    margin-left: 0 !important;
  }
  .isDis .el-checkbox__input.is-disabled+span.el-checkbox__label , .isDis .el-radio__input.is-disabled+span.el-radio__label , .isDis  .el-input.is-disabled .el-input__inner{
    color: #555;
  }
  .pdt .queCorrect .el-radio__input.is-checked + .el-radio__label {
      color: #24b46d ;
  }
  .pdt .queCorrect .el-radio__input.is-checked .el-radio__inner {
     border-color: #24b46d ;
  }
  .pdt .queCorrect .el-radio__input.is-disabled.is-checked .el-radio__inner::after {
      background-color: #24b46d;
      width: 6px;
      height: 6px;
  }
  .pdt .queError .el-radio__input.is-checked + .el-radio__label {
     color: #ce5453;
  }
  .pdt .queError .el-radio__input.is-checked .el-radio__inner {
     border-color: #ce5453;
  }
  .pdt .queError .el-radio__input.is-disabled.is-checked .el-radio__inner::after {
      background-color: #ce5453;
      width: 6px;
      height: 6px;
  }
  .pdt .queCorrect .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner , .pdt .queCorrect .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
      border-color: #24b46d;
  }
  .pdt .queError .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner , .pdt .queError .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
      border-color: #ce5453;
  }
  .fl{
      float: left;
  }
  .fr{
      float: right;
  }
  .pt30{
      padding-top: 30px;
  }
  .mb100{
      margin-bottom: 100px;
  }
  .mtb60{
      margin: 60px 0;
  }
  .el-carousel__item{
      height: auto;
  }
  .elDialogs.imgsDialogs .el-dialog{
      background: url('../src/assets/images/gradeBg.png') 100% 100% no-repeat;
      background-size: cover;
      border-radius: 15px;
  }
  .bg333{
      background-color: #333;
  }
  .w200{
      width: 200px;
  }
  .mtb20{
      margin: 20px 0;
  }
  .tl{
      text-align: left !important;
  }
  .eltables .el-table td.el-table__cell, .eltables .el-table--border .el-table__cell{
      border:none;
  }
  .elRowsHis .el-radio__label{
      display: none;
  }
  .elRowsHis .el-radio{
      width: 100%;
      display: inline-block;
  }
  .eltextarea  .el-textarea__inner{
      border: 1px solid #f9f9fb;
  }
  .rates .el-rate__icon {
      font-size: 30px;
  }
	.next button span{
      padding-left:  20px;
      padding-right:  20px;
	}
  .hisElTables.el-table.el-table--border .el-table__cell {
      padding-left: 30px;
      border-right: none !important;
  }
  .hisElTables.el-table td.el-table__cell {
      border-bottom: 1px solid #f2f3f7;
  }
  .historyWrap .el-row{
      margin-left: 0 !important;
      margin-right: 0 !important;
  }
  .mtb80{
      margin: 80px auto;
  }
  .btnUpload , .btnUpload .el-upload{
      border: none !important;
  }
	.avatar-uploader .el-upload{
		  display: none;
	}
  .el-menu-vertical-demo{
      border-right: none;
  }
  .el-menu-vertical-demo .submenu__titleNews{
      background-color: #f3f3f3;
  }

  ::-webkit-scrollbar { width: 7px; height: 14px; }
  ::-webkit-scrollbar-track,
  ::-webkit-scrollbar-thumb { border-radius: 999px; border: 5px solid transparent; }
  ::-webkit-scrollbar-track { box-shadow: 1px 1px 5px rgba(0,0,0,.2) inset; }
  ::-webkit-scrollbar-thumb { min-height: 20px; background-clip: content-box; box-shadow: 0 0 0 5px rgba(0,0,0,.2) inset; }
  ::-webkit-scrollbar-corner { background: transparent; }
  
  .el-form-item__error{
      padding-left: 15px;
      padding-top: 10px;
  }
  .w100{
      width:100%
  }
  body{
      background-color:#f7f7f7;
  }
  .whiteBg{
      background-color: #fff;
  }
  .wraps{
      margin: 15px auto;
  }
  .el-pagination button:disabled{
      background-color: transparent !important;
  }
  .el-tabs__item{
      font-size: 17px;
  }
  .el-tabs__active-bar {
      height: 3px;
  }
  .el-tabs__nav-wrap::after {
      background-color: #e4e7ed4a;
  }
  .proDet{
      padding: 30px 40px;
      border-radius: 8px;
      box-sizing: border-box;
  }
  .el-divider {
      background-color: #dcdfe652 !important;
  }
  .dialogs .el-dialog__body {
      padding: 30px 40px;
  }
  .el-pagination .btn-next, .el-pagination .btn-prev  , .el-pager li{
      background: transparent;
  }
  .el-rate.rates {
      height: auto;
      line-height: 1;
  }
  .ratesNew .el-rate__icon {
      font-size: 18px;
      margin-right: 3px;
  }
  .el-rate.rates .el-rate__icon{
     margin-right: 0;
  }
  .el-pagination{
      text-align: center;
      margin: 30px 0;
  }
  .mtb10{
      margin: 10px auto;
  }
  .mb50{
      margin-bottom: 50px;
  }
  .el-date-editor.w100.el-input, .el-date-editor.el-input__inner{
      width: 100%;
  }
  .channels .el-menu-item.is-active {
      color: #333 !important;
  } 
  .prism-player .prism-live-display{
      display: none !important;
  }
  .elMenus.el-menu{
      border-right:none !important;
  }
  .selecteEl .el-input--suffix .el-input__inner{
      background-color: #f2f3f7 !important;
      border: none !important;
  }
  .elTabsOrder{
      margin: 30px 0;
  }
  .elTabsOrder .el-tabs__item {
      font-size: 15px;
  }
  .elTabsOrder .el-tabs__header {
      margin: 0 0 25px;
  }
  .elTabsOrder .el-tabs__nav-wrap::after{
      content: '';
      height: 0 !important;
  }
	.inteItems{
		padding: 20px 30px;
		background-color: #fff;
	}
  .el-button.is-round{
      border-radius: 10px !important;
  }
  .el-pager li.active {
      width: 28px !important;
      height: 28px !important;
      line-height: 28px !important;
      border-radius: 5px !important;
  }
  .el-pager li, .el-pagination button, .el-pagination span:not([class*=suffix]) {
      width: 28px !important;
      height: 28px !important;
      line-height: 28px !important;
      color: #666;
  }
	.courseElButton.el-button--primary {
		color: #FFF;
		background-color: #24b8ff;
		border-color: #24b8ff;
	}
  .proImgList img.img{
      object-fit: cover;
      height:130px;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue